/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PaymentMethodSetNicknamePathParams,
	PaymentMethodSetNicknameRequest,
	PaymentMethodSetNicknameResponse,
} from '../types/PaymentMethodSetNickname'

/**
 * PATCH /:organisation/payment-methods/:paymentMethod/nickname
 * @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::setNickname
 */
export async function paymentMethodSetNickname(
	organisation: PaymentMethodSetNicknamePathParams['organisation'],
	paymentMethod: PaymentMethodSetNicknamePathParams['paymentMethod'],
	data: PaymentMethodSetNicknameRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PaymentMethodSetNicknameResponse>> {
	return axiosInstance.patch(`/${organisation}/payment-methods/${paymentMethod}/nickname`, data, config)
}
